<template>
    <v-container>
        <v-row>
            <v-col :xs="12" md="3">
                <!--<v-row>
                    <v-col :xs="12">
                        <v-card width="100%">
                            <v-card-title>
                                Total sales
                            </v-card-title>
                            <v-card-text>
                                <v-simple-table dense>
                                    <tbody>
                                    <tr>
                                        <td>Lifetime sale</td>
                                        <td v-bind="allTimeSales"></td>
                                    </tr>
                                    <tr>
                                        <td>Last 30 Days</td>
                                        <td v-bind="lastMonthSales"></td>
                                    </tr>
                                    <tr>
                                        <td>Last 7 Days</td>
                                        <td v-bind="lastWeekSales"></td>
                                    </tr>
                                    <tr>
                                        <td>Last 24 Hours</td>
                                        <td v-bind="last24hSales"></td>
                                    </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>

                </v-row>-->
                <!--<v-row>
                    <v-col :xs="12">
                        <v-card>
                            <v-card-title>
                                Total Completed Sales
                            </v-card-title>
                            <v-card-text>
                                <v-simple-table dense>
                                    <tbody>
                                    <tr>
                                        <td>Lifetime sale</td>
                                        <td v-bind="allTimeCompletedSales"></td>
                                    </tr>
                                    <tr>
                                        <td>Last 30 Days</td>
                                        <td v-bind="lastMonthCompletedSales"></td>
                                    </tr>
                                    <tr>
                                        <td>Last 7 Days</td>
                                        <td v-bind="lastWeekCompletedSales"></td>
                                    </tr>
                                    <tr>
                                        <td>Last 24 Hours</td>
                                        <td v-bind="last24hCompletedSales"></td>
                                    </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>-->
                <v-row>
                    <v-col :xs="12">
                        <v-card>
                            <v-card-title>
                                Order Status
                            </v-card-title>
                            <v-card-text>
                                <v-simple-table dense>
                                    <thead>
                                    <tr>
                                        <th>Description</th>
                                        <th># of orders</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td><router-link :to="{name: 'orders-list', query: {status: newStatusName}}">New Orders</router-link></td>
                                        <td>{{newOrdersAmount}}</td>
                                    </tr>
                                    <tr>
                                        <td><router-link :to="{name: 'orders-list', query: {status: manualPaymentStatusName}}">Manual Payment</router-link></td>
                                        <td>{{manualPaymentOrdersAmount}}</td>
                                    </tr>
                                    <tr>
                                        <td><router-link :to="{name: 'orders-list', query: {status: pendingStatusName}}">Pending Orders</router-link></td>
                                        <td>{{pendingOrdersAmount}}</td>
                                    </tr>
                                    <tr>
                                        <td><router-link :to="{name: 'orders-list', query: {status: pendingDispatchStatusName}}">Pending Dispatch Orders</router-link></td>
                                        <td>{{pendingDispatchOrdersAmount}}</td>
                                    </tr>
                                    <tr>
                                        <td><router-link :to="{name: 'orders-list', query: {status: completedStatusName}}">Completed Orders</router-link></td>
                                        <td>{{completedOrdersAmount}}</td>
                                    </tr>
                                    <tr>
                                        <td><router-link :to="{name: 'orders-list', query: {status: unpaidStatusName}}">Unpaid Orders</router-link></td>
                                        <td>{{unpaidOrdersAmount}}</td>
                                    </tr>
                                    <tr>
                                        <td><router-link :to="{name: 'orders-list', query: {status: refundedStatusName}}">Refunded Orders</router-link></td>
                                        <td>{{refundedOrdersAmount}}</td>
                                    </tr>
                                    <tr>
                                        <td><router-link :to="{name: 'orders-list', query: {status: cancelledStatusName}}">Cancelled Orders</router-link></td>
                                        <td>{{cancelledOrdersAmmount}}</td>
                                    </tr>
                                    <tr>
                                        <td><router-link :to="{name: 'orders-list', query: {status: notSupportedStatusStatusName}}">Not supported status Orders</router-link></td>
                                        <td>{{notSupportedStatusOrdersAmmount}}</td>
                                    </tr>
                                    <tr>
                                        <td><router-link :to="{name: 'orders-list', query: {status: faultyStatusName}}">FAULTY ORDERS</router-link></td>
                                        <td>{{faultyOrdersAmount}}</td>
                                    </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
            <v-col :xs="12" :lg="9">
                <v-card>
                    <v-card-title>
                        Orders
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :options.sync="options"
                            :server-items-length="totalItems"
                            :loading="loading"
                            :footer-props="footerProps"
                            :dense="dense"
                            :search="search"
                            class="elevation-1"
                    >
                        <template v-slot:item.editButton="{ item }">
                            <v-btn :to="{name: 'order-details', params: {id: item.id}}" dark x-small>Edit</v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
  const axios = require('axios')
  import {getFormattedDate} from '@/helpers/dateFormatters.js'

  export default {
    name: "OrdersList",
    data() {
      return {
        footerProps: {
          "itemsPerPageOptions": [25, 50, 100]
        },
        dense: true,
        totalItems: 0,
        search: "",
        items: [],
        loading: true,
        options: {},
        headers: [
          {text: 'Order ID', value: 'idAtStore'},
          {text: 'Website', value: 'website'},
          {text: 'Order Date', value: 'orderDate'},
          {text: 'Delivery Name', value: 'deliveryName'},
          {text: 'Original Delivery Date', value: 'originalEstimatedDeliveryDate'},
          {text: 'Actual Delivery Date', value: 'actualEstimatedDeliveryDate'},
          //{text: 'Delivery Date', value: 'deliveryDate'},
          //{text: 'Total', value: 'total'},
          {text: 'Status', value: 'status'},
          {text: 'Edit', value: 'editButton', sortable: false}
        ],
        allTimeSales: 0,
        lastMonthSales: 0,
        lastWeekSales: 0,
        last24hSales: 0,
        allTimeCompletedSales: 0,
        lastMonthCompletedSales: 0,
        lastWeekCompletedSales: 0,
        last24hCompletedSales: 0,
        newOrdersAmount: 0,
        manualPaymentOrdersAmount: 0,
        pendingOrdersAmount: 0,
        pendingDispatchOrdersAmount: 0,
        completedOrdersAmount: 0,
        refundedOrdersAmount: 0,
        unpaidOrdersAmount: 0,
        cancelledOrdersAmmount: 0,
        faultyOrdersAmount: 0,
        notSupportedStatusOrdersAmmount: 0,
        newStatusName: "new_order",
        manualPaymentStatusName: "manual_payment",
        pendingStatusName: "pending",
        pendingDispatchStatusName: "pending_dispatch",
        completedStatusName: "completed",
        refundedStatusName: "refunded",
        unpaidStatusName: "unpaid",
        cancelledStatusName: "cancelled",
        notSupportedStatusStatusName: "not_supported",
        faultyStatusName: "faulty",
        statusForFilter: ""
      }
    },
    watch: {
      options: {
        handler() {
          this.getOrdersFromApi()
            .then(data => {
              this.loading = false
              this.items = this.prepareItemsForList(data.items)
              this.totalItems = data.total
            })
        },
        deep: true,
      },
      search: {
        handler(){
            if (this.search === "" || this.search.length >= 3){
              console.log("searching")
              this.getOrdersFromApi()
                .then(data => {
                  this.loading = false
                  this.items = this.prepareItemsForList(data.items)
                  this.totalItems = data.total
                })
            }
        }
      },
      "$route": {
        deep: true,
        handler(){
          this.setStatusForFilter()
        }
      },
      statusForFilter: {
        handler(){
          this.getOrdersFromApi()
            .then(data => {
              this.loading = false
              this.items = this.prepareItemsForList(data.items)
              this.totalItems = data.total
            })
        }
      }
    },
    mounted() {
      this.getOrderStatusSummary()
      this.setStatusForFilter()
    },
    methods: {
      getOrdersFromApi() {
        this.loading = true
        return new Promise((resolve) => {
            //const {sortBy, sortDesc, page, itemsPerPage} = this.options
            var redirectToLoginFunction = this.redirectToLogin
            var limit = this.options.itemsPerPage
            var offset = (this.options.page - 1) * this.options.itemsPerPage
            var params = {
              limit: limit,
              offset: offset,
            }
            if (this.search.length >= 3){
              params.search = this.search
            }

            if (this.statusForFilter) {
              params.status = this.$route.query.status
            }

            axios.get("/api/orders/", {
              params: params,
              headers: {
                Authorization: "Token " + this.$store.getters.authToken
              }
            }).then(function (response) {
              var total = response.data.count
              var items = response.data.results
              resolve({
                  items,
                  total,
                }
              )
            }).catch(function (error) {
              if (403 === error.response.status) {
                alert("Failed to obtain data")
                redirectToLoginFunction()
              }
            })
          }
        )
      },
      redirectToLogin() {
        this.$router.push({name: 'login'})
      },
      prepareItemsForList(items) {
        var parsedItems = []
        for (var i = 0; i < items.length; i++) {
          var item = items[i]


          var parsedItem = {
            id: item.id,
            idAtStore: item.id_at_store,
            customerName: item.customer_details.name,
            deliveryName: item.delivery_address.name,
            website: item.store.name,
            actualEstimatedDeliveryDate: getFormattedDate(item.actual_estimated_delivery_date),
            originalEstimatedDeliveryDate: getFormattedDate(item.original_estimated_delivery_date),
            orderDate: getFormattedDate(item.created_at),
            status: item.status
          }
          parsedItems.push(parsedItem)
        }
        return parsedItems
      },
      getOrderStatusSummary(){
        return new Promise(() => {

          var redirectToLoginFunction = this.redirectToLogin
            axios.get("/api/orders_status_summary/", {
              headers: {
                Authorization: "Token " + this.$store.getters.authToken
              }
            }).then(this.setOrderStatusSummaryValues).catch(function (error) {
              if (403 === error.response.status) {
                alert("Failed to obtain data")
                redirectToLoginFunction()
              }
            })
          }
        )
      },
      setOrderStatusSummaryValues(response) {
        var statusesSummary = response.data
        this.newOrdersAmount = statusesSummary.new_order
        this.manualPaymentOrdersAmount = statusesSummary.manual_payment
        this.pendingOrdersAmount = statusesSummary.pending
        this.pendingDispatchOrdersAmount = statusesSummary.pending_dispatch
        this.completedOrdersAmount = statusesSummary.completed
        this.refundedOrdersAmount = statusesSummary.refunded
        this.unpaidOrdersAmount = statusesSummary.unpaid
        this.cancelledOrdersAmmount = statusesSummary.cancelled
        this.notSupportedStatusOrdersAmmount = statusesSummary.not_supported
        this.faultyOrdersAmount = statusesSummary.faulty
      },
      setStatusForFilter(){
        this.statusForFilter = this.$route.query.status
      }
    },
  }
</script>

<style scoped>

</style>